export const container = `block text-primary-100 transition-colors hover:text-primary-200 text-nowrap overflow-hidden text-ellipsis`;
